<template>
  <div class="">
    <h3 class="pt-0 mt-0 pb-0">{{ $t("viewAMSearch.title") }}</h3>
    <v-toolbar elevation="0" dense rounded class="mt-3">
      <v-toolbar-items>
        <v-btn small text :to="{name:'am-search'}" exact>{{ $t("navigation.am_search") }}</v-btn>
        <v-btn small text :to="{name:'am-crosses'}"> {{ $t('navigation.crosses')}}</v-btn>
        <v-btn small text :to="{name:'am-aliases'}"> {{ $t('navigation.aliases')}}</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-layout>
      <v-row class="mx-0 w-100">
        <v-col md="6" cols="12" class="px-0">
          <v-card class="px-3 py-2 ma-0" elevation="0">
            <v-row ma-0>
              <v-col cols="11" md="11" class="pb-0 pr-0">
                <v-text-field
                  ma-0
                  pa-0
                  outlined
                  :placeholder="$t('viewAMSearch.Start_typing_the_part_code')"
                  append-icon="fa-search"
                  @click:append="searchBrand"
                  hide-details
                  v-model="part_number"
                  @keyup="autosearch ? searchBrand() : ''"
                  @keyup.enter="searchBrand"
                ></v-text-field>
              </v-col>
              <v-col cols="1" md="1" class="pb-0 text-left">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on">
                    <v-switch
                        v-model="autosearch"
                        :title="$t('viewSuppliersSearch.auto_search_title')"
                    ></v-switch>
                    </div>
                  </template>
                  <span>{{ $t('viewSuppliersSearch.auto_search_title') }}</span>
                </v-tooltip>

              </v-col>
            </v-row>
          </v-card>
          <v-card class="px-3 py-2 ma-0 mt-8" elevation="0">
            <v-row ma-0>
              <v-col cols="6" class="pb-0 pr-0">
                <v-text-field
                  ma-0
                  outlined
                  :placeholder="$t('common.brand')"
                  hide-details
                  v-model="replacementsFor.brand"
                  @keyup.enter="showReplacementBtnClick"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  ma-0
                  outlined
                  :placeholder="$t('common.part_code')"
                  append-icon="fa-search"
                  hide-details
                  @click:append="showReplacementBtnClick"
                  v-model="replacementsFor.part_number"
                  @keyup.enter="showReplacementBtnClick"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-data-table
              v-if="loaderBrandsGet"
              :headers="tableHeader"
              :items="tableBrandsGet"
              class="elevation-0 mb-3"
              :footer-props="table.options"
              :hide-default-footer="true"
              :items-per-page="10000"
              :class="{ 'mb-0': $vuetify.breakpoint.mdAndUp }"
            >
              <template v-slot:item="props">
                <tr>
                  <td
                    class="text-xs-left pointer"
                    @click="
                      showReplacement(
                        props.item.brand_name,
                        props.item.search_number
                      )
                    "
                  >
                    {{ props.item.brand_name }}
                  </td>
                  <td
                    class="text-xs-left pointer"
                    @click="
                      showReplacement(
                        props.item.brand_name,
                        props.item.search_number
                      )
                    "
                  >
                    {{ props.item.part_name }}
                  </td>
                  <td
                    class="text-xs-left pointer"
                    @click="
                      showReplacement(
                        props.item.brand_name,
                        props.item.search_number
                      )
                    "
                  >
                    <template v-if="isImg(props.item.images_small[0])">
                      <img
                        style="height: 30px"
                        :src="props.item.images_small[0]"
                      />
                    </template>
                  </td>
                </tr>
              </template>
              <template v-slot:no-data>
                {{ $t("common.no_data_available") }}
              </template>
              <template v-slot:no-results>
                {{ $t("common.no_data_available") }}
              </template>
              <template slot="pageText" slot-scope="item">
                {{ item.pageStart }} - {{ item.pageStop }}
                {{ $t("viewAMSearch.pagination_of") }} {{ item.itemsLength }}
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col md="6" xs="12" class="mr-0 pr-0">
          <v-card
            class="pa-3 mt-0"
            elevation="0"
            v-if="loaderReplacementsGet || tableReplacements.show"
          >
            <v-progress-circular
              v-if="loaderReplacementsGet"
              indeterminate
              color="primary"
              class="mt-3 mb-3 mx-auto d-block"
            ></v-progress-circular>
            <v-layout row class="d-flex flex-nowrap pa-3 pt-0">
              <v-flex
                shrink
                v-if="
                  tableReplacements.img && tableReplacements.img != '' && tableReplacements.show
                "
                class="replacementImageWrap"
              >
                <img :src="tableReplacements.img" />
              </v-flex>
              <v-flex>
                <h1 v-if="tableReplacements.show">
                  {{ tableReplacements.title }}
                </h1>
                <h2 v-if="tableReplacements.show && tableReplacements.subTitle">
                  {{ tableReplacements.subTitle }}
                </h2>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex>
                <v-dialog
                  v-model="dialogApplicability"
                  scrollable
                  max-width="600px"
                >
                  <template v-slot:activator="{ on }">
                    <div
                      v-on="on"
                      class="pointer flex py-0 mx-1"
                      v-show="applicability.show"
                    >
                      <v-btn
                        v-if="tableReplacements.show"
                        large
                        color="success"
                        class="ma-0 ml-1 elevation-0"
                      >
                        <v-icon small left>fa-info-circle</v-icon
                        >{{ $t("viewAMSearch.Applicability") }}</v-btn
                      >
                    </div>
                  </template>
                  <v-card>
                    <v-card-actions>
                      <h3 class="pl-2">
                        {{ $t("viewAMSearch.Applicability") }}
                      </h3>
                      <v-spacer></v-spacer>

                      <v-btn icon @click="dialogApplicability = false">
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </v-card-actions>
                    <v-divider></v-divider>
                    <v-card-text class="ma-0 pa-0">
                      <div class="pa-3">
                        <div
                          v-for="item in applicability.items"
                          :key="item[0]"
                          class="pb-3"
                        >
                          <h3>{{ item[0] }}</h3>
                          <div v-for="car in item[1]" :key="car[0]">
                            {{ car.model_name }},
                            {{ $t("viewAMSearch.manufacturing_date") }}:
                            {{ car.manufacturing_date }}
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-flex>
            </v-layout>
            <v-data-table
              v-if="!loaderReplacementsGet && tableReplacements.show"
              :headers="tableReplacementsHeader"
              :items="tableReplacements.items"
              class="elevation-0"
              :footer-props="table.options"
              :hide-default-footer="true"
              :items-per-page="10000"
            >
              <template v-slot:item="props">
                <tr>
                  <td
                    class="text-xs-left pointer pl-0"
                    @click="
                      showReplacement(
                        props.item.brand_name,
                        props.item.search_number
                      )
                    "
                  >
                    <v-tooltip
                      top
                      v-if="
                        userCrosses[
                          props.item.brand_name + ':' + props.item.search_number
                        ] === true
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <span class="isUserCross">{{
                            props.item.brand_name
                          }}</span
                          ><v-icon x-small color="green lighten-1"
                            >fa-user-circle</v-icon
                          >
                        </span>
                      </template>
                      <span>{{ $t("viewAMSearch.this_is_users_cross") }}</span>
                    </v-tooltip>
                    <span
                      :class="{ isExcludedCross: props.item.isExcludedCross }"
                      v-else
                      >{{ props.item.brand_name }}</span
                    >
                  </td>
                  <td
                    class="text-xs-left pointer"
                    @click="
                      showReplacement(
                        props.item.brand_name,
                        props.item.search_number
                      )
                    "
                  >
                    {{ props.item.search_number }}
                  </td>
                  <td
                    class="text-xs-left pointer"
                    @click="
                      showReplacement(
                        props.item.brand_name,
                        props.item.search_number
                      )
                    "
                  >
                    {{ props.item.part_name }}
                  </td>
                  <td
                    class="text-xs-left pointer"
                    @click="
                      showReplacement(
                        props.item.brand_name,
                        props.item.search_number
                      )
                    "
                  >
                    <template v-if="isImg(props.item.images_small[0])">
                      <img
                        style="height: 30px"
                        :src="props.item.images_small[0]"
                      />
                    </template>
                  </td>
                  <td class="text-xs-left">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <div v-if="!props.item.isExcludedCross">
                            <v-btn
                                elevation="0"
                                min-width="36"
                                min-height="36"
                                @click.stop="deleteCross(
                                    props.item.brand_name,
                                    props.item.search_number
                                  )"
                                color="red lighten-2"
                                class="mb-0 px-0 white--text"
                            >
                               <v-icon
                                   v-if="
                                  userCrosses[
                                    props.item.brand_name +
                                      ':' +
                                      props.item.search_number
                                  ] === true
                                "
                                   small
                               >$trash</v-icon
                               >
                              <v-icon small v-else >fa-times-circle</v-icon
                              >
                            </v-btn>
                          </div>
                          <div v-else>
                            <v-btn
                              elevation="0"
                              min-width="36"
                              min-height="36"
                              @click.stop="
                                restoreCross(
                                  props.item.brand_name,
                                  props.item.search_number
                                )
                              "
                              class="mb-0 px-0 white--text"
                              color="secondary"
                            >
                              <v-icon small>fa-redo</v-icon>
                            </v-btn>
                          </div>
                        </span>
                      </template>
                      <div v-if="!props.item.isExcludedCross">
                        <span
                          v-if="
                            userCrosses[
                              props.item.brand_name +
                                ':' +
                                props.item.search_number
                            ] === true
                          "
                          >{{
                            $t(
                              "viewAMCrosses.Delete_user_s_cross_reference_from_search"
                            )
                          }}</span
                        >
                        <span v-else>{{
                          $t("viewAMSearch.Exclude_cross_reference_from_search")
                        }}</span>
                      </div>
                      <div v-else>
                        <span>{{
                          $t("viewAMSearch.Restore_cross_reference_to_search")
                        }}</span>
                      </div>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
              <template v-slot:no-data>
                {{ $t("common.no_data_available") }}
              </template>
              <template v-slot:no-results>
                {{ $t("common.no_data_available") }}
              </template>
              <template slot="pageText" slot-scope="item">
                {{ item.pageStart }} - {{ item.pageStop }}
                {{ $t("viewAMSearch.pagination_of") }} {{ item.itemsLength }}
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
    <v-layout row wrap pa-3> </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import { mapFields } from "vuex-map-fields";
axios.defaults.withCredentials = true;
export default {
  props: {
    lang: "",
    levamHeight: "",
  },
  data: () => ({
    dialogApplicability: false,
    autosearch: true,
    loader: false,
    choosePartBrandName: "",
    choosePartPartCode: "",
    table: {
      options: {
        "items-per-page": [10000, 25, 50],
        "next-icon": "navigate_next",
        "prev-icon": "navigate_before",
      },
    },
  }),
  mounted() {},
  computed: {
    ...mapFields("am_search", [
      "part_number",
      "fetched",
      "tableBrandsGet",
      "loaderBrandsGet",
      "loaderReplacementsGet",
      "time",
      "replacementsFor",
      "tableReplacements",
      "applicability",
      "userCrosses",
      "userExcludedCrosses",
    ]),
    formattedTime() {
      if (this.time) {
        let time = String(this.time).slice(0, 7);
        return time;
      }
      return "";
    },
    tableHeader() {
      return [
        { text: this.$t("common.brand"), value: "brand_name", sortable: true },
        {
          text: this.$t("common.description"),
          value: "part_name",
          sortable: true,
        },
        {
          text: this.$t("common.picture"),
          value: "images_small",
          sortable: false,
        },
      ];
    },
    tableReplacementsItems() {
      let data = this.tableReplacements.items;
      let ex = [];
      if (this.userExcludedCrosses != []) {
        ex = this.userExcludedCrosses.map((one) => {
          let res = one.split(":");
          return {
            brand_name: res[0],
            aliases: {},
            search_number: res[1],
            part_name: "",
            images_small: [],
            isExcludedCross: true,
          };
        });
      }
      return data.concat(ex);
    },
    tableReplacementsHeader() {
      return [
        { text: this.$t("common.brand"), value: "brand_name", sortable: true, class:'pl-0' },
        {
          text: this.$t("common.part_code"),
          value: "search_number",
          sortable: true,
        },
        {
          text: this.$t("common.description"),
          value: "part_name",
          sortable: false,
        },
        {
          text: this.$t("common.picture"),
          value: "images_small",
          sortable: false,
        },
        { text: this.$t("common.actions"), sortable: false },
      ];
    },
    language() {
      return this.lang;
    },
  },
  methods: {
    resizeWrap() {
      this.$emit("resize-wrap");
    },

    isImg(img) {
      if (img) {
        if (img.length > 0) {
          return true;
        }
      }
      return false;
    },
    showReplacementBtnClick() {
      this.showReplacement(
        this.replacementsFor.brand,
        this.replacementsFor.part_number
      );
    },
    deleteCross(brandName, partNumber) {
      this.$store
        .dispatch("am_search/deleteCross", {
          brandName: brandName,
          partNumber: partNumber,
        })
        .then((response) => {
          this.showReplacement(
            this.replacementsFor.brand,
            this.replacementsFor.part_number
          );
          if (response.data.status === "success")
            this.$inform(this.$t("common.success_remove"));
        });
    },
    restoreCross(brandName, partNumber) {
      this.$store
        .dispatch("am_search/restoreCross", {
          brandName: brandName,
          partNumber: partNumber,
        })
        .then((response) => {
          this.showReplacement(
            this.replacementsFor.brand,
            this.replacementsFor.part_number
          );
          if (response.data.status === "success")
            this.$inform(this.$t("common.operation_success"));
        });
    },
    showReplacement(choosePartBrandName, choosePartPartCode) {
      if (choosePartPartCode.length < 1 || choosePartBrandName.length < 1)
        return;
      this.replacementsFor.part_number = choosePartPartCode;
      this.replacementsFor.brand = choosePartBrandName;
      this.$store.dispatch("am_search/replacementsGet");
    },
    searchBrand() {
      if (this.part_number.length < 1) return;
      this.$store.dispatch("am_search/brandsGet").then(() => {});
    },
  },
};
</script>

<style>
.replacementImageWrap {
  float: left;
  margin-right: 10px;
}
.replacementImageWrap img {
  height: 100px;
  margin-top: 5px;
}
.isUserCross {
  color: green;
}
.isExcludedCross {
  color: gray;
  text-decoration: line-through;
}
</style>
